// #region import
import React from 'react';
import {
  DEVICE_TYPE_TEXT,
  DEVICE_TYPE_ALL_TEXT,
  DEVICE_TYPE_ANDROID_TEXT,
  DEVICE_TYPE_IOS_TEXT,
  DEVICE_TYPE_ANDROID_CODE,
  DEVICE_TYPE_IOS_CODE,
  NOTIFICATION_TYPE_TEXT,
  NOTIFICATION_TYPE_ALL_TEXT,
  NOTIFICATION_TYPE_1_TEXT,
  NOTIFICATION_TYPE_2_TEXT,
  NOTIFICATION_TYPE_3_TEXT,
  NOTIFICATION_TYPE_4_TEXT,
  NOTIFICATION_TYPE_5_TEXT,
  NOTIFICATION_TYPE_1_CODE,
  NOTIFICATION_TYPE_2_CODE,
  NOTIFICATION_TYPE_3_CODE,
  NOTIFICATION_TYPE_4_CODE,
  NOTIFICATION_TYPE_5_CODE,
  IS_DEBUG_TEXT,
  IS_DEBUG_ALL_TEXT,
  IS_DEBUG_ONLY_TEXT,
  IS_DEBUG_NOT_TEXT,
  IS_DEBUG_ON_CODE,
  IS_DEBUG_OFF_CODE,
} from '../../../util/Const';
import getBytes from '../../../util/StringUtil';
// #endregion import

/**
 * キーワードコンポーネント
 * @param keyword
 * @param setKeyword
 */
export const Keyword = (props: any) => {
  const { keyword, setKeyword } = props;
  const onChange = (text: string) => {
    setKeyword(text);
  };

  return (
    <>
      <dt>検索文字列</dt>
      <dd>
        <input
          type="text"
          value={keyword}
          className={
            keyword != null && getBytes(keyword) > 256 ? 'border_red' : ''
          }
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChange(e.target.value)
          }
        />
      </dd>
    </>
  );
};

/**
 * デバイスタイプコンポーネント
 * @param device
 * @param setDevice
 */
export const DeviceType = (props: any) => {
  const { device, setDevice } = props;

  const onChange = (e: any) => {
    switch (e.target.value) {
      case DEVICE_TYPE_ANDROID_CODE:
        setDevice(DEVICE_TYPE_ANDROID_CODE);
        break;
      case DEVICE_TYPE_IOS_CODE:
        setDevice(DEVICE_TYPE_IOS_CODE);
        break;
      default:
        setDevice('');
        break;
    }
  };

  return (
    <>
      <dt>{DEVICE_TYPE_TEXT}</dt>
      <dd>
        <label>
          <input
            type="radio"
            id="all_device"
            value="all"
            checked={device === undefined || device === ''}
            onChange={onChange}
          />
          <label htmlFor="all_device" className="radio">
            {DEVICE_TYPE_ALL_TEXT}
          </label>
        </label>
        <label>
          <input
            type="radio"
            id="device_android"
            value={DEVICE_TYPE_ANDROID_CODE}
            checked={device != null && device === DEVICE_TYPE_ANDROID_CODE}
            onChange={onChange}
          />
          <label htmlFor="device_android" className="radio">
            {DEVICE_TYPE_ANDROID_TEXT}
          </label>
        </label>
        <label>
          <input
            type="radio"
            id="device_ios"
            value={DEVICE_TYPE_IOS_CODE}
            checked={device != null && device === DEVICE_TYPE_IOS_CODE}
            onChange={onChange}
          />
          <label htmlFor="device_ios" className="radio">
            {DEVICE_TYPE_IOS_TEXT}
          </label>
        </label>
      </dd>
    </>
  );
};

/**
 * 送信種別コンポーネント
 * @param type
 * @param setType
 */
export const NotificationType = (props: any) => {
  const { type, setType } = props;

  const onChange = (e: any) => {
    setType(Number(e.target.value));
  };

  return (
    <>
      <dt>{NOTIFICATION_TYPE_TEXT}</dt>
      <dd>
        <label>
          <input
            type="radio"
            id="notification_type_all"
            value={-1}
            checked={type === undefined || type === -1}
            onChange={onChange}
          />
          <label htmlFor="notification_type_all" className="radio">
            {NOTIFICATION_TYPE_ALL_TEXT}
          </label>
        </label>
        <label>
          <input
            type="radio"
            id="notification_type_5"
            value={NOTIFICATION_TYPE_5_CODE}
            checked={type === NOTIFICATION_TYPE_5_CODE}
            onChange={onChange}
          />
          <label htmlFor="notification_type_5" className="radio">
            {NOTIFICATION_TYPE_5_TEXT}
          </label>
        </label>
        <label>
          <input
            type="radio"
            id="notification_type_1"
            value={NOTIFICATION_TYPE_1_CODE}
            checked={type === NOTIFICATION_TYPE_1_CODE}
            onChange={onChange}
          />
          <label htmlFor="notification_type_1" className="radio">
            {NOTIFICATION_TYPE_1_TEXT}
          </label>
        </label>
        <label>
          <input
            type="radio"
            id="notification_type_2"
            value={NOTIFICATION_TYPE_2_CODE}
            checked={type === NOTIFICATION_TYPE_2_CODE}
            onChange={onChange}
          />
          <label htmlFor="notification_type_2" className="radio">
            {NOTIFICATION_TYPE_2_TEXT}
          </label>
        </label>
        <label>
          <input
            type="radio"
            id="notification_type_3"
            value={NOTIFICATION_TYPE_3_CODE}
            checked={type === NOTIFICATION_TYPE_3_CODE}
            onChange={onChange}
          />
          <label htmlFor="notification_type_3" className="radio">
            {NOTIFICATION_TYPE_3_TEXT}
          </label>
        </label>
        <label>
          <input
            type="radio"
            id="notification_type_4"
            value={NOTIFICATION_TYPE_4_CODE}
            checked={type === NOTIFICATION_TYPE_4_CODE}
            onChange={onChange}
          />
          <label htmlFor="notification_type_4" className="radio">
            {NOTIFICATION_TYPE_4_TEXT}
          </label>
        </label>
      </dd>
    </>
  );
};

/**
 * テスト通知コンポーネント
 * @param isDebug
 * @param setIsDebug
 */
export const IsDebug = (props: any) => {
  const { isDebug, setIsDebug } = props;

  const onChange = (e: any) => {
    setIsDebug(Number(e.target.value));
  };

  return (
    <>
      <dt>{IS_DEBUG_TEXT}</dt>
      <dd>
        <label>
          <input
            type="radio"
            id="is_debug_all"
            value={-1}
            checked={isDebug === undefined || isDebug === -1}
            onChange={onChange}
          />
          <label htmlFor="is_debug_all" className="radio">
            {IS_DEBUG_ALL_TEXT}
          </label>
        </label>
        <label>
          <input
            type="radio"
            id="is_debug_only"
            value={IS_DEBUG_ON_CODE}
            checked={isDebug === IS_DEBUG_ON_CODE}
            onChange={onChange}
          />
          <label htmlFor="is_debug_only" className="radio">
            {IS_DEBUG_ONLY_TEXT}
          </label>
        </label>
        <label>
          <input
            type="radio"
            id="is_debug_not"
            value={IS_DEBUG_OFF_CODE}
            checked={isDebug === IS_DEBUG_OFF_CODE}
            onChange={onChange}
          />
          <label htmlFor="is_debug_not" className="radio">
            {IS_DEBUG_NOT_TEXT}
          </label>
        </label>
      </dd>
    </>
  );
};
